<script>
import form from '@/utils/form';

import BaseField from '@/components/BaseField.vue';
import SupplierManualDir from '@/components/dir/supplierManual/SupplierManualDir.vue';
import FileUploaderSingle from '@/components/file/FileUploaderSingle.vue';

import { units } from '@/utils/enum';

export default {
  name: 'MaterialBidForm',
  components: { FileUploaderSingle, SupplierManualDir, BaseField },
  props: {
    item: Object,
  },
  data() {
    return {
      supplier: null,
      offer: null,
      form: {
        volume: form.createFieldObject('float', 'Объем упаковки', ''),
        volumeUnit: form.createFieldObject('select', 'Единица измерения', null, {}, units.volume),
        deliveryDate: form.createFieldObject('date', 'Дата поставки', ''),
        price: form.createFieldObject('int', 'Цена упаковки', ''),
        priceCurrency: form.createFieldObject('select', 'Валюта', null, {}, units.currency),
        color: form.createFieldObject('string', 'Цвет', ''),
        quantity: form.createFieldObject('float', 'Количество упаковок', ''),
        size: form.createFieldObject('string', 'Размер', ''),
        name: form.createFieldObject('string', 'Название (артикул)', ''),
        comment: form.createFieldObject('textarea', 'Комментарий', ''),
      },
    };
  },
  mounted() {
    if (!this.item) return;
    form.setValues(this.form, this.item);
    this.supplier = this.item.supplierManual?.['@id'];
    this.offer = this.item.offer;
  },
  computed: {
    totalVolume() { return this.form.quantity.value * this.form.volume.value; },
    totalPrice() { return this.form.quantity.value * this.form.price.value; },
    volumeUnit() { return units.volume[this.form.volumeUnit?.value]; },
    priceCurrency() { return units.currency[this.form.priceCurrency?.value]; },
  },
  methods: {
    save() {
      const data = form.getValues(this.form);
      data.supplierManual = this.supplier;
      data.offer = this.offer?.['@id'];
      this.$emit('save', data);
      form.clear(this.form);
      this.offer = null;
      this.supplier = null;
    },
    cancel() {
      this.$emit('close');
      form.clear(this.form);
      this.offer = null;
      this.supplier = null;
    },
  },
};
</script>

<template lang="pug">
.material-bid-form
  SupplierManualDir(v-model="supplier")
  FileUploaderSingle.avatar(:file="offer" @change="offer = $event" title="КП")
  BaseField(
    v-for="(field, name) in form"
    v-model="field.value"
    v-bind="field"
    :key="name"
    :class="[name]"
  )
  .total-volume Всего материала
    span(v-if="totalVolume") {{ totalVolume }} {{ volumeUnit }}
    span(v-else) -
  .total-price Сумма
    span(v-if="totalPrice") {{ totalPrice }} {{ priceCurrency }}
    span(v-else) -
  .buttons
    Btn(sm grey @click="cancel()") Отмена
    Btn(sm @click="save()") Сохранить


</template>

<style scoped lang="scss">
  .material-bid-form {
    padding: 30px;
    display: grid;
    grid-template-columns: 2fr 1fr 2fr 2fr 2fr;
    gap: 10px 30px;
    background: #FBFCFD;
    border-radius: 6px;
  }

  .avatar {
    grid-column: 2;
    grid-row: 1 / 4 span;
  }

  .comment {
    grid-column: 4;
    grid-row: 3 / 2 span;

    &::v-deep textarea {
      min-height: 100%;
    }
  }

  .priceCurrency {
    grid-column: 4;
    grid-row: 2;
  }

  .volumeUnit {
    grid-column: 4;
    grid-row: 1;
  }

  .total-volume {
    grid-column: 5;
    grid-row: 1;
  }

  .total-price {
    grid-column: 5;
    grid-row: 2;
  }

  .total-price, .total-volume {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
  }

  .buttons {
    grid-column: 5;
    grid-row: 3;

    display: flex;
    gap: 20px
  }
</style>
